import {
  FETCH_COURSES_BY_CLASS_BEGIN,
  FETCH_COURSES_BY_CLASS_FULFILLED,
  FETCH_COURSES_BY_CLASS_REJECTED,
  FETCH_COURSES_BY_PROGRAM_BEGIN,
  FETCH_COURSES_BY_PROGRAM_FULFILLED,
  FETCH_COURSES_BY_PROGRAM_REJECTED,
  FETCH_COURSES_BY_STUDENT_BEGIN,
  FETCH_COURSES_BY_STUDENT_FULFILLED,
  FETCH_COURSES_BY_STUDENT_REJECTED,
  FETCH_COURSES_BY_TEACHER_BEGIN,
  FETCH_COURSES_BY_TEACHER_FULFILLED,
  FETCH_COURSES_BY_TEACHER_REJECTED,
  FETCH_BEST_COURSE_BY_SCHOOL_BEGIN,
  FETCH_BEST_COURSE_BY_SCHOOL_FULFILLED,
  FETCH_BEST_COURSE_BY_SCHOOL_REJECTED,
  FETCH_COURSESINPROGRESS_BY_SCHOOL_BEGIN,
  FETCH_COURSESINPROGRESS_BY_SCHOOL_FULFILLED,
  FETCH_COURSESINPROGRESS_BY_SCHOOL_REJECTED,
  FETCH_COURSE_LIST_BEGIN,
  FETCH_COURSE_LIST_FULFILLED,
  FETCH_COURSE_LIST_REJECTED
} from "../actions/courseActions";

const FetchCourse = (
  state = {
    course: {
      id: null,
      name: null,
      defaultPrice: null,
      description: null,
      modules: {
        id: null,
        name: null,
        price: null
      }
    },
    fetching: false,
    fetech: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case "FETCH_COURSE": {
      return { ...state, fetching: true };
    }
    case "FETCH_COURSE_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    case "FETCH_COURSE_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        programLicence: action.payload
      };
    }

    default: {
      return {
        ...state
      };
    }
  }
};

const INIT_COURSE_LIST = {
  error: null,
  loading: true,
  result: []
};

export function fetchCourseList(state = INIT_COURSE_LIST, action = {}) {
  switch (action.type) {
    case FETCH_COURSE_LIST_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSE_LIST_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSE_LIST_REJECTED: {
      return {
        ...state,
        error: action.payload.error,
        result: []
      };
    }
    default: {
      return { ...state };
    }
  }
}

const INIT_COURSE_BY_CLASS = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function coursesByClassReducer(
  state = INIT_COURSE_BY_CLASS,
  action = {}
) {
  switch (action.type) {
    case FETCH_COURSES_BY_CLASS_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSES_BY_CLASS_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSES_BY_CLASS_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_COURSE_BY_PROGRAM = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function coursesByProgramReducer(
  state = INIT_COURSE_BY_PROGRAM,
  action = {}
) {
  switch (action.type) {
    case FETCH_COURSES_BY_PROGRAM_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSES_BY_PROGRAM_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSES_BY_PROGRAM_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}
const INIT_COURSE_BY_STUDENT = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function coursesByStudentReducer(
  state = INIT_COURSE_BY_STUDENT,
  action = {}
) {
  switch (action.type) {
    case FETCH_COURSES_BY_STUDENT_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSES_BY_STUDENT_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSES_BY_STUDENT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_COURSE_BY_TEACHER = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function coursesByTeacherReducer(
  state = INIT_COURSE_BY_TEACHER,
  action = {}
) {
  switch (action.type) {
    case FETCH_COURSES_BY_TEACHER_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSES_BY_TEACHER_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSES_BY_TEACHER_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_BEST_COURSE = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function bestCourseBySchoolReducer(
  state = INIT_BEST_COURSE,
  action = {}
) {
  switch (action.type) {
    case FETCH_BEST_COURSE_BY_SCHOOL_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_BEST_COURSE_BY_SCHOOL_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_BEST_COURSE_BY_SCHOOL_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_COURSESINPROGRESS = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};
export function coursesInProgressBySchoolReducer(
  state = INIT_COURSESINPROGRESS,
  action = {}
) {
  switch (action.type) {
    case FETCH_COURSESINPROGRESS_BY_SCHOOL_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_COURSESINPROGRESS_BY_SCHOOL_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_COURSESINPROGRESS_BY_SCHOOL_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}
export default FetchCourse;